document.addEventListener('DOMContentLoaded', function () {
  const checkbox = document.querySelector('.show_additinal_settings');
  const wrapper = document.querySelector('.additional_settings_picker');
  if (!checkbox || !wrapper) return;
  const update = () => {
    wrapper.style.display = checkbox.checked ? '' : 'none';
  };
  update();
  checkbox.addEventListener('change', update);

  const drawinguploadcheckbox = document.querySelector('.drawing-upload-checkbox');
  console.log('drawing uploadcheckbox',drawinguploadcheckbox)
  const drawinguploadinputfields = document.querySelector('.drawing-upload-inpufields')
  
  if(drawinguploadcheckbox)
  { 
  drawinguploadcheckbox.addEventListener("click",function(){ 
    console.log('checkingdsfjkdsjkdsfjk')
    drawinguploadcheckbox.classList.toggle('active');
    drawinguploadinputfields.classList.toggle('hidden')
  })
  }
});
